import { useEffect, useRef } from 'react';

type CompareFn<T> = (prev: T, next: T) => boolean;

export function useMemoCompare<T>(next: T, compare: CompareFn<T>): T {
  const previousRef = useRef<T>(next);
  const previous = previousRef.current;

  const isEqual = compare(previous, next);

  useEffect(() => {
    if (!isEqual) {
      previousRef.current = next;
    }
  });
  return isEqual ? previous : next;
}
